const initPackSection = (sectionEl) => {
  if (!sectionEl || sectionEl.dataset.packSliderInit === 'true') return;

  const sliderComponent = sectionEl.querySelector('.product-pack-purphyt__slider');
  const navButtons = sectionEl.querySelectorAll('.product-pack-purphyt__nav-button');
  if (!sliderComponent || !navButtons.length) return;

  const bindNavigation = () => {
    if (!sliderComponent.slider) {
      requestAnimationFrame(bindNavigation);
      return;
    }

    const splide = sliderComponent.slider;

    const updateActiveState = () => {
      navButtons.forEach((button) => {
        button.classList.toggle('is-active', Number(button.dataset.packSlideTarget) === splide.index);
      });
    };

    navButtons.forEach((button) => {
      button.addEventListener('click', () => {
        splide.go(Number(button.dataset.packSlideTarget));
      });
    });

    splide.on('mounted', updateActiveState);
    splide.on('move', updateActiveState);
    updateActiveState();

    sectionEl.dataset.packSliderInit = 'true';
  };

  bindNavigation();
};

const initPackSections = (root = document) => {
  root.querySelectorAll('.product-pack-purphyt').forEach(initPackSection);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initPackSections());
} else {
  initPackSections();
}

document.addEventListener('shopify:section:load', (event) => {
  initPackSections(event.target);
});
